import classNames from 'classnames/bind';
import React from 'react';

import type { IImageProps } from '@components/Image/Image';
import { Image } from '@components/Image/Image';
import { Text } from '@components/Text/Text';

import styles from './PanelItem.module.scss';

interface IProps {
  title: string;
  description: string;
  image: IImageProps;
  className?: string;
}

const cx = classNames.bind(styles);

export const PanelItem: React.FC<IProps> = ({ title, description, image, className }) => (
  <div className={cx('wrapper', className)}>
    <div className={styles.header}>
      <Text className="mb-3" display="block" size={24} tag="strong">
        {title}
      </Text>
      <Text className="mb-6" color="gray500" display="block" size={16} tag="p">
        {description}
      </Text>
    </div>
    <div className={styles.imageWrapper}>
      <Image
        alt=""
        className={styles.image}
        height={image.height}
        src={image.src}
        width={image.width}
      />
    </div>
  </div>
);
